module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-bg-2-sp-98f4c4f0841692bb0129693360b22a1c.png";